export default __webpack_public_path__ + "static/media/demologo.15b03f8f.png";